import { useProtectedAPI } from "./apiService";
import { objectToQueryString } from "@/utils/objectToQueryString";
import useSWR from "swr";


export const useAdminGetRegionsSWR= () => {
    const protectedApi = useProtectedAPI();
    const fetcher = (url) => protectedApi.get(url).then((res) => res.data);

    const { data, error, isLoading, isValidating, mutate } = useSWR("/admin/regions", fetcher);

    return {
        data,
        error,
        isLoading,
        isValidating,
        callToAction: mutate,
    };
}



export const useAdminGetRegions= () => {
    const protectedAPI = useProtectedAPI()

    const adminGetRegions = async (filters) => {
        const queryString = objectToQueryString(filters)
        const url = `/admin/regions?${queryString}`
        const response = await protectedAPI.get(url)
        return response.data
    }
    
    return adminGetRegions
}



export const useAdminGetRegion= () => {
    const protectedAPI = useProtectedAPI()

    const adminGetRegion = async (id) => {
        const response = await protectedAPI.get(`/admin/regions/${id}`)
        return response.data
    }

    return adminGetRegion
}



export const useAdminCreateRegion= () => {
    const protectedAPI = useProtectedAPI();

    const adminCreateRegion = async (data) => {
        const response = await protectedAPI.post(`/admin/regions`, data)
        return response.data
    };

    return adminCreateRegion;
}



export const useAdminUpdateRegion= () => {
    const protectedAPI = useProtectedAPI();

    const adminUpdateRegion = async (id, data) => {
        const response = await protectedAPI.put(`/admin/regions/${id}`, data)
        return response.data
    };

    return adminUpdateRegion;
}



export const useAdminDeleteRegion= () => {
    const protectedAPI = useProtectedAPI();

    const adminDeleteRegion = async (id) => {
        const response = await protectedAPI.delete(`/admin/regions/${id}`)
        return response.data
    };

    return adminDeleteRegion;
}